import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import * as firebase from '@/services/firebase'

const mapAuthProviders = {
  firebase: {
    login: firebase.login,
    register: firebase.register,
    currentAccount: firebase.currentAccount,
    logout: firebase.logout,
  },
}

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    id: '',
    name: '',
    role: '',
    email: '',
    avatar: '',
    questionsViewed: '',
    questionsSaved: '',
    authorized: process.env.VUE_APP_AUTHENTICATED || false, // false is default value
    loading: false,
    isSubscribed: false,
    isLoaded: false,
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    LOGIN({ commit, dispatch, rootState }, { payload }) {
      const { email, password } = payload
      commit('SET_STATE', {
        loading: true,
      })

      const login = mapAuthProviders[rootState.settings.authProvider].login
      login(email, password).then(success => {
        if (success) {
          dispatch('LOAD_CURRENT_ACCOUNT')
          Vue.prototype.$notification.success({
            message: 'Logged In',
            description: 'Login successful. You will be redirected shortly.',
          })
        }
        if (!success) {
          commit('SET_STATE', {
            loading: false,
          })
        }
      })
    },
    REGISTER({ commit, dispatch, rootState }, { payload }) {
      const { email, password, name } = payload
      commit('SET_STATE', {
        loading: true,
      })

      const register = mapAuthProviders[rootState.settings.authProvider].register
      register(email, password, name).then(success => {
        if (success) {
          dispatch('LOAD_CURRENT_ACCOUNT')
          Vue.prototype.$notification.success({
            message: 'Success',
            description: 'You have successfully registered and will be redirected shortly.',
          })
          router.push({ name: 'pricing' })
        }
        if (!success) {
          commit('SET_STATE', {
            loading: false,
          })
        }
      })
    },
    async LOAD_CURRENT_ACCOUNT({ commit, dispatch, rootState }) {
      if (!rootState.user.isLoaded) {
        commit('SET_STATE', {
          loading: true,
        })
        await firebase.firebaseAuth
          .onAuthStateChanged(function(user) {
            if (user) {
              // User is signed in.
              firebase.firebaseFirestore
                .collection('users')
                .doc(user.uid)
                .onSnapshot((doc) => {
                  const id = user.uid
                  const name = doc.data().displayName
                  const role = doc.data().role
                  const avatar = doc.data().photoUrl
                  const email = doc.data().email
                  const questionsSaved = doc.data().questionsSaved
                  const questionsViewed = doc.data().questionsViewed
                  const premiumPlans = ['pro', 'unlimited']
                  const expireDate = doc.data().status.expireDate
                  const tier = expireDate > Math.trunc(Date.now() / 1000) ? doc.data().status.tier : 'basic'
                  const isSubscribed = (Math.trunc(Date.now() / 1000) <= expireDate) && premiumPlans.includes(tier)
                  commit('SET_STATE', {
                    id,
                    name,
                    email,
                    avatar,
                    role,
                    tier,
                    questionsSaved,
                    questionsViewed,
                    authorized: true,
                    isLoaded: true,
                    expireDate,
                    isSubscribed,
                  })
                  console.log('User state updated')
                  // Removed because basic tier is now free
                  // if (!isSubscribed) {
                  //   console.log('No active subscription')
                  //   router.push({ name: 'pricing' })
                  // }
                  if (rootState.content.topics.length > 0) {
                    console.log('Topics already loaded')
                  } else {
                    dispatch('content/getTopics', null, { root: true })
                      .then(console.log('Topics loaded from user login'))
                  }
                })
              commit('SET_STATE', {
                loading: false,
              })
              return true
            } else {
              // No user is signed in.
              dispatch('LOGOUT')
              commit('SET_STATE', {
                loading: false,
              })
              return false
            }
          })
      } else return rootState.user.isLoaded
    },
    LOGOUT({ commit, rootState }) {
      const logout = mapAuthProviders[rootState.settings.authProvider].logout
      logout().then(() => {
        commit('SET_STATE', {
          id: '',
          name: '',
          role: '',
          email: '',
          avatar: '',
          tier: '',
          authorized: false,
          loading: false,
        })
        router.push('/auth/login')
      })
    },
  },
  getters: {
    user: state => state,
  },
}
